import { reactive } from 'vue';

export type ToastVariant = 'success' | 'error' | 'warning' | 'info';

export type ToastItem = {
  id: string;
  message: string;
  variant: ToastVariant;
  timeoutMs: number;
  createdAt: number;
};

export const toastStore = reactive({
  toasts: [] as ToastItem[],
});

function uid(): string {
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function pushToast(message: string, variant: ToastVariant = 'info', timeoutMs = 3500): void {
  const id = uid();
  toastStore.toasts.push({ id, message, variant, timeoutMs, createdAt: Date.now() });
  if (timeoutMs > 0) {
    window.setTimeout(() => {
      const idx = toastStore.toasts.findIndex((t) => t.id === id);
      if (idx >= 0) toastStore.toasts.splice(idx, 1);
    }, timeoutMs);
  }
}

export function clearToast(id: string): void {
  const idx = toastStore.toasts.findIndex((t) => t.id === id);
  if (idx >= 0) toastStore.toasts.splice(idx, 1);
}
